import React from 'react';
import { withRender } from 'utils/render';

import {
  Wrapper,
  CenterWrapper,
  CompanyWrapper,
  Content,
  Spacer,
  Break,
  MediaWrapper,
} from './style';
import {
  CompanyEmail,
  CompanyPhone,
  CompanyAddress,
} from 'variables';
import {
  IconBlog, IconFacebook, IconInstagram, IconPost,
} from 'assets';

const Footer:React.FC = _ => {
  const media = ['facebook', 'blog', 'post', 'instagram'];

  return (
    <Wrapper>
      <CenterWrapper>
        <CompanyWrapper>
          <Content>
            주식회사 텐핑거스(대표 신동해)
            <Break />
            <Spacer />
            사업자 등록번호: 119-86-86868
          </Content>
          <Content>
            대표 전화: {CompanyPhone}
            <Break />
            <Spacer />
            제휴/문의: {CompanyEmail}
          </Content>
          <Content>
            {CompanyAddress}
          </Content>
        </CompanyWrapper>
        <MediaWrapper>
          {
            media.map((m, i) => {
              return (
                <a 
                  key={i}
                  href={
                    m === 'facebook' ? 'https://www.facebook.com/gogodate/' :
                    m === 'blog' ? 'http://blog.naver.com/seouldatepop' :
                    m === 'post' ? 'http://post.naver.com/seouldatepop' : 'https://www.instagram.com/datepop/'
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={
                    m === 'facebook' ? IconFacebook :
                    m === 'blog' ? IconBlog :
                    m === 'post' ? IconPost : IconInstagram
                  } alt="아이콘" />
                </a>
              );
            })
          }
        </MediaWrapper>
      </CenterWrapper>
    </Wrapper>
  );
};

export default withRender(Footer);
